<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import GradeTypes from '$lib/PageSections/GradeTypes/GradeTypes.svelte';
	import WhatDoTheyCost from '$lib/PageSections/WhatDoTheyCost/WhatDoTheyCost.svelte';

	import WindowInsertImage from './images/Solutions-Light-UV-001.jpg';
	import SoundProofRoom from './images/Solutions-Light-UV-0021.png';
	import paralaxImage from './images/Solutions-Light-UV-paralax-bottom.png?w=1200;1000;800;600;400;';
	import SectionDataDrivenResults from './sections/data-driven-results/SectionDataDrivenResults.svelte';
</script>

<Section backgroundColor="white">
	<h2>Window Light Blocking Solutions</h2>
	<p>
		Indow offers three window light-blocking solutions to help you reduce air
		conditioning bills, gain privacy, or create darkness for better sleep. Our
		custom-made inserts fit windows using silicone compression tubing so they
		press into place without mounting hardware.
	</p>
	<p>
		There are many unique challenges when it comes to controlling light. Indow
		inserts create custom window sun protection and window privacy solutions
		without having to replace your windows, add blinds, or hang curtains.
	</p>
	<p>
		<a href="/custom-storm-windows/sleep-panel">Sleep Panels</a> block out all light
		for 100% darkness.
	</p>
	<p>
		<a href="/custom-storm-windows/museum-grade">Museum Grade</a> blocks 98% UV rays
		and increases energy efficiency.
	</p>
	<p>
		<a href="/custom-storm-windows/privacy-grade">Privacy Grade</a> diffuses light
		for privacy without blocking natural light.
	</p>
	<Image
		src={WindowInsertImage}
		alt="indow window uv light solutions"
		title="woman installing soundproofing window insert"
	/>
</Section>

<Section backgroundColor={'white'}>
	<h2>Sun Protection for Windows + Noise and Heat Blocking</h2>
	<p>
		Like all our inserts, each of our window light-blocking solutions add energy
		efficiency and reduce noise. In addition to protecting your furniture or
		providing privacy, Indow inserts will also:
	</p>
	<Bubble backgroundColor="transparent">
		<ul class="w-auto">
			<li>Reduce 50% of outside noise.*</li>
			<li>Increase comfort by eliminating drafts.</li>
			<li>Lower heating & cooling bills up to 20%.</li>
			<li>Install & remove easily.</li>
		</ul>
	</Bubble>
</Section>

<Section backgroundColor={'white'}>
	<h2>Ways to Block Sunlight from Windows</h2>
	<p>
		<b>Sleep Panel</b> –
		<a href="/custom-storm-windows/sleep-panel">Blackout window inserts</a>
		provide 100% darkness and 50% noise reduction. Because of their snug fit, these
		panels block out ALL LIGHT, no creeping rays around the edges. The panels are
		made of medium density fiberboard with a white surface facing the inside of the
		room. This material also helps control room temperature. They install and uninstall
		in minutes with easy storage under the bed.
	</p>
	<p>
		<b>Museum Grade</b> –
		<a href="/custom-storm-windows/museum-grade">UV window protection</a> prevents
		fading on wood floors, furniture, & artwork. These inserts block 98% of UV rays
		while allowing natural light through. They offer the same noise reduction and
		temperature control as the Sleep Panel. With UV protection for windows, you are
		protecting your other home investments.
	</p>
	<p>
		<b>Privacy Grade</b> –
		<a href="/custom-storm-windows/privacy-grade">Window privacy inserts</a>
		that still allow natural light. These inserts are translucent, so block the view
		coming through the window, but allow light to fill the room. The surface of the
		insert is “clouded” which hides fingerprints and the compression seal helps reduce
		condensation (easy bathroom cleaning). They offer the same noise reduction and
		temperature control as the Sleep Panel.
	</p>
	<p class="footnote">
		*We want to ensure our inserts help solve your noise problem. Overall noise
		reduction depends on the amount of noise coming through your walls,
		ceilings, floors, doors, and existing windows. Noise reduction will be less
		when placed over double-pane windows. Read our full
		<a href="/noise-disclaimer/">Noise Reduction Sheet</a> to learn more.
	</p>
</Section>

<WhatDoTheyCost version={2} backgroundColor={'blue'} />

<Section backgroundColor={'grey-light'}>
	<h2>Testimonials</h2>
	<p>
		Marla Yorsten in Texas found the solar window protection kept the sun from
		fading her favorite artwork.
	</p>
	<Image src={SoundProofRoom} alt="indow window uv solutions testimonial" />
	<p class="quote">
		“I don't want the sunlight to damage my stuff,” she said. “But I want my
		windows just the way they are.” The inserts “look beautiful.”
	</p>
	<p>– Marla Y, Texas</p>
	<a class="quote" href="/resources/case-studies">Read more case studies.</a>
</Section>

<SectionDataDrivenResults />

<Awards />
<GetAFreeEstimate />
<GradeTypes backgroundColor="grey-light" />
<Parallax image={paralaxImage} />
<FeaturedArticles />

<style>
	.quote {
		font-size: 1.25rem;
		color: var(--color-indow-blue);
		font-style: italic;
	}
</style>
